import { Dialog } from '@strata/react-dialog';
import { FullscreenLoading } from '@strata/react-fullscreen-loading';

import { ClaimDetails, usePostClaimStatusCheckMutation } from 'store/api/medbillingApi';

interface CheckClaimStatusDialogProps {
    isOpen: boolean;
    onClose: () => void;
    claimDetails?: ClaimDetails;
}

export const CheckClaimStatusDialog = ({
    isOpen,
    onClose,
    claimDetails = undefined,
}: CheckClaimStatusDialogProps) => {
    const [postClaimStatusCheck, { isLoading }] = usePostClaimStatusCheckMutation();

    return (
        <>
            <FullscreenLoading
                isShowing={isLoading}
                loadingText={
                    <>
                        <p>Checking claim status.</p>
                        <p>
                            We appreciate your patience, this process could take up to one minute.
                        </p>
                    </>
                }
            />
            <Dialog
                dialogTitle="Check Claim Status"
                isOpen={isOpen && !isLoading}
                primaryButtonLabel="Yes, Check Status"
                onPrimaryButtonClick={() => {
                    (async () => {
                        if (claimDetails) {
                            await postClaimStatusCheck({
                                payerId: claimDetails.payerId,
                                referralId: claimDetails.referralId,
                                transactionId: claimDetails.transactionId,
                            }).unwrap();
                            onClose();
                        }
                    })();
                }}
                secondaryButtonLabel="No, Return To Claim"
                onSecondaryButtonClick={onClose}
                dialogContent={
                    <>
                        <p>
                            This will check for any status updates for the claim and any services.
                        </p>
                        <p>Are you sure you want to continue?</p>
                    </>
                }
            />
        </>
    );
};
